import { useEffect } from 'react';

// N-125: сюда ведёт кнопка «Войти в кабинет врача» из админки — короткоживущий токен
// приходит в query. Кладём в sessionStorage (НЕ localStorage) — sessionStorage не шарится
// между вкладками одного origin, поэтому импersonation в новой вкладке не подменяет
// реальную сессию врача, если у него уже открыта своя вкладка кабинета в этом же браузере
// (см. authInterceptor.js — он приоритизирует sessionStorage-токен на каждый запрос).
// Публичный роут (без guard) — сам токен и есть авторизация.
export default function AdminSession() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('impersonated', '1');
    }
    window.location.replace('/dashboard');
  }, []);
  return null;
}
